// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__171wB","content":"styles_content__1koPI","selectAll":"styles_selectAll__1AQAn"};